import { ApiFee } from '../../../api/_legacy/generated-api'
import { unpascal, unpascalFeeType } from './unpascal'

function toPercentage(value: number) {
  if (Number.isNaN(value)) {
    return '-'
  }

  const result = value * 100

  // Wondering what the + is for?
  // See: https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
  return +result.toFixed(2)
}

function convertFee(fee: ApiFee) {
  return {
    name: unpascalFeeType(fee.feeType),
    rate: `${toPercentage(fee.feeRate)}% p.a.`,
    calculatedOn: unpascal(fee.feeBasis),
    isVatApplicable: fee.isVATApplicable,
    frequency: unpascal(fee.feeDeductionFrequency),
    counterpartyId: fee.counterPartyId
  }
}

export function formatFees(fees: ApiFee[]) {
  if (!Array.isArray(fees)) {
    return []
  }

  return fees.map(convertFee)
}
